document.addEventListener('DOMContentLoaded', function () {
  function fixEmptyCartDrawer() {
    var cart = document.getElementById('cart');
    if (!cart) return;
    var empty = cart.querySelector('.empty');
    if (!empty) return;

    empty.textContent = 'Your cart is empty.';

    if (!cart.querySelector('.archford-empty-cart-actions')) {
      var actions = document.createElement('p');
      actions.className = 'archford-empty-cart-actions';
      actions.innerHTML = '<a class="archford-empty-cart-link" href="/collections/all">Browse Products</a>';
      var parent = empty.closest('p');
      if (parent) parent.insertAdjacentElement('afterend', actions);
    }
  }

  fixEmptyCartDrawer();

  var observer = new MutationObserver(function () {
    fixEmptyCartDrawer();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
